// extracted by mini-css-extract-plugin
export var alignDiscLeft = "s_rj d_fp d_bG d_dv";
export var alignLeft = "s_p8 d_fp d_bG d_dv";
export var alignDiscCenter = "s_rk d_fq d_bD d_dw";
export var alignCenter = "s_bP d_fq d_bD d_dw";
export var alignDiscRight = "s_rl d_fr d_bH d_dx";
export var alignRight = "s_p9 d_fr d_bH d_dx";
export var footerContainer = "s_rm d_dW d_bW";
export var footerContainerFull = "s_rn d_dT d_bW";
export var footerHeader = "s_kf d_kf";
export var footerTextWrapper = "s_rp d_w";
export var footerDisclaimerWrapper = "s_km d_km d_ck";
export var badgeWrapper = "s_rq d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "s_rr d_bz d_bJ d_bN d_bL";
export var wide = "s_rs d_cy";
export var right = "s_rt d_bK";
export var line = "s_fk d_fl d_cv";
export var badgeDisclaimer = "s_rv d_bC d_bP d_bJ";
export var badgeContainer = "s_rw d_bz d_bH d_bP";
export var badge = "s_rx";
export var padding = "s_ry d_c7";
export var end = "s_rz d_bH";
export var linkWrapper = "s_rB d_dB";
export var link = "s_mZ d_dB";
export var colWrapper = "s_rC d_cx";
export var consent = "s_f d_f d_bC d_bP";
export var disclaimer = "s_rD d_bz d_bJ";
export var media = "s_rF d_bx d_dy";
export var itemRight = "s_rG";
export var itemLeft = "s_rH";
export var itemCenter = "s_rJ";
export var exceptionWeight = "s_rK C_s8";